<oo-bar-bottom-row>
  <nav [tabPanel]="tabPanel" disableRipple mat-align-tabs="center" mat-tab-nav-bar>
    <a (click)="updateNavTo('standings')" [active]="state.currentRoute === 'standings'"
       mat-tab-link
       routerLink="./standings">
      <mat-icon>emoji_events</mat-icon>
    </a>
    <a (click)="updateNavTo('forms')" [active]="state.currentRoute === 'forms'"
       mat-tab-link
       routerLink="./forms">
      <mat-icon>article</mat-icon>
    </a>
    <a (click)="updateNavTo('participants')" [active]="state.currentRoute === 'participants'"
       mat-tab-link
       routerLink="./participants">
      <mat-icon>groups</mat-icon>
    </a>
    <a (click)="updateNavTo('configurations')" [active]="state.currentRoute === 'configurations'"
       mat-tab-link
       routerLink="./configurations">
      <mat-icon>settings</mat-icon>
    </a>
  </nav>
</oo-bar-bottom-row>

<oo-loading-container [status]="state.status">
  <mat-tab-nav-panel #tabPanel>
    <ng-template>
      <div class="oo-container">
        <router-outlet></router-outlet>
      </div>
    </ng-template>
    <!-- this is a dirty hack to prevent hydration bug which caused the ui to be duplicated -->
    <ng-content></ng-content>
    <!-- this is a dirty hack to prevent hydration bug which caused the ui to be duplicated -->
  </mat-tab-nav-panel>
</oo-loading-container>

